import type { FaireProductEntity } from "../../entity_types/product";

export const p_t8wqdy4awf: FaireProductEntity = {
  token: "p_t8wqdy4awf",
  type: "product",
  name: "Butter Mode Sensory Toys",
  brandToken: "b_f1bkinpani",
  brandName: "NYSLIFE",
  imageUrl:
    "https://cdn.faire.com/fastly/489bf357781fd6ba4c0b10addbcab6e8a10992ffb0ceb088a8be6197603ac367.png",
  galleryImageUrls: [],
  priceDollars: 2.95,
  description:
    "1 Order = 48 Pieces (2 Counter Displays)\n\nSlow Rise and Squishy Butter \n\nResembles and smells like real butter!",
  tags: [],
  msrpDollars: 5.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:58:38.112Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
